import { URLS } from '@constants'
import { GETAction, PayloadCreateAction } from '@types'

import { commonAPI } from './common.api'

export const actionAPI = commonAPI.injectEndpoints({
  endpoints: build => ({
    fetchActionById: build.query<GETAction, number | string | void>({
      query: id => ({
        url: URLS.FRONT_CFG + `/action/id/${id}`,
      }),
    }),
    fetchAction: build.mutation<GETAction, number | string | void>({
      query: id => ({
        url: URLS.FRONT_CFG + `/action/id/${id}`,
      }),
    }),
    createAction: build.mutation<GETAction, PayloadCreateAction>({
      query: action => ({
        url: URLS.FRONT_CFG + `/action`,
        method: 'POST',
        body: { ...action, id: undefined },
      }),
      invalidatesTags: ['SingleView', 'SingleForm'],
    }),
    createActionWithId: build.mutation<GETAction, PayloadCreateAction>({
      query: action => ({
        url: URLS.FRONT_CFG + `/action`,
        method: 'POST',
        body: action,
      }),
      invalidatesTags: [],
    }),
    updateAction: build.mutation<GETAction, PayloadCreateAction>({
      query: action => ({
        url: URLS.FRONT_CFG + `/action`,
        method: 'POST',
        body: action,
      }),
      invalidatesTags: ['SingleView', 'SingleForm'],
    }),
    deleteAction: build.mutation<void, number | string>({
      query: id => ({
        url: URLS.FRONT_CFG + `/action/id/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['SingleView', 'SingleForm'],
    }),
  }),
})

export const {
  useFetchActionByIdQuery,
  useFetchActionMutation,
  useCreateActionMutation,
  useCreateActionWithIdMutation,
  useUpdateActionMutation,
  useDeleteActionMutation,
} = actionAPI
